import actionTypes from '../constants/action-types';

const clearGlobalsHtml = () => ({
  type: actionTypes.CLEAR_GLOBALS_HTML,
});

export default clearGlobalsHtml;
